import { useGetSurcharges } from 'queries';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { ControlledSelect } from 'components/shared';

export const SurchargesSelect = () => {
  const { t } = useTranslation('common', { keyPrefix: 'surchargeRelations' });
  const { control } = useFormContext();
  const { data: options } = useGetSurcharges();

  return (
    <ControlledSelect
      variant="outlined"
      control={control}
      label={t('surchargeName')}
      name="surchargeId"
      options={options ?? []}
    />
  );
};
